/**
 * @ngdoc services
 * @memberof mercury.modules.settings
 * @name Company
 * @description Data access service for users to manage companies
 */
angular.module('mercury.modules.settings.company')
.factory('Company', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var Companies = $resource(settings.apiHost + '/r/Companies', {id: '@id'});

  /**
   * Get all companies the current user has access to
   *
   * @memberof Company
   */
  function getAll() {
    return Companies.query().$promise;
  }

  /**
   * Get the full details of a specific company
   *
   * @memberof Company
   * @param  {String} id Id of the company to get
   */
  function get(id) {
    var deferred = $q.defer();

    $http.get(settings.apiHost + '/r/Companies/' + id, {headers: {'x-loaded-company-id': id}})
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * Send an invite to a user for the specific company
   *
   * @memberof Company
   * @param  {Object} userInvite User invite model
   * @param  {String} companyId  Id of the company to invite to
   */
  function createInvite(userInvite, companyId) {
    var deferred = $q.defer();

    $http.post(settings.apiHost + '/r/CompanyInvites', userInvite, {headers: {'x-loaded-company-id': companyId}})
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * Update the permissions of an existing user
   *
   * @memberof Company
   * @param  {Object} userPermission Updated user permission model
   * @param  {String} companyId      Id of the company the permission belongs to
   */
  function updatePermission(userPermission, companyId) {
    return $http.put(settings.apiHost + '/r/UserCompanyPermissions/' + userPermission.id, userPermission, {headers: {'x-loaded-company-id': companyId}});
  }

  /**
   * Remove a user permission from the company
   *
   * @memberof Company
   * @param  {Object} userPermission user permission model to remove
   * @param  {String} companyId      Id of the company the permission belongs to
   */
  function removePermission(userPermission, companyId) {
    return $http.delete(settings.apiHost + '/r/UserCompanyPermissions/' + userPermission.id, {headers: {'x-loaded-company-id': companyId}});
  }

  /**
   * Update the details of a user invite
   *
   * @memberof Company
   * @param  {Object} userInvite     Updated user invite model
   * @param  {String} companyId      Id of the company the invite belongs to
   */
  function updateInvite(userInvite, companyId) {
    return $http.put(settings.apiHost + '/r/CompanyInvites/' + userInvite.id, userInvite, {headers: {'x-loaded-company-id': companyId}});
  }

  /**
   * Remove a user invite
   *
   * @memberof Company
   * @param  {Object} userInvite User invite model to remove
   * @param  {String} companyId      Id of the company the invite belongs to
   */
  function removeInvite(userInvite, companyId) {
    return $http.delete(settings.apiHost + '/r/CompanyInvites/' + userInvite.id, {headers: {'x-loaded-company-id': companyId}});
  }

  function transferOwner(companyId, userId) {
    return $http.post(settings.apiHost + '/r/Companies/?transferOwner=1',
    {newOwnerId: userId},
    {headers: {'x-loaded-company-id': companyId}});
  }

  function cancelTransferOwner(companyId) {
    return $http.post(settings.apiHost + '/r/Companies/?cancelTransfer=1',
    {cancelOwnerCompanyId: companyId},
    {headers: {'x-loaded-company-id': companyId}});
  }

  function acceptTransfer(companyId, userId, accepts) {
    return $http.post(settings.apiHost + '/r/Companies/?acceptOwnership=1',
    {userId: userId, ownershipClaimCompanyId: companyId, acceptOwnership: accepts},
    {headers: {'x-loaded-company-id': companyId}});
  }

  function inviteSupport(companyId) {
    var url = settings.mercHost + '/companies/support-invites/invite';
    if (companyId) {
      url += '?invitedCompanyId=' + companyId;
    }
    return $http.post(url);
  }

  function revokeSupport() {
    return $http.post(settings.mercHost + '/companies/support-invites/revoke');
  }

  return {
    getAll: getAll,
    get: get,
    createInvite: createInvite,
    updatePermission: updatePermission,
    removePermission: removePermission,
    updateInvite: updateInvite,
    removeInvite: removeInvite,
    transferOwner: transferOwner,
    cancelTransferOwner: cancelTransferOwner,
    acceptTransfer: acceptTransfer,
    inviteSupport: inviteSupport,
    revokeSupport: revokeSupport
  };
}]);
